import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpService} from 'src/app/services/http.service';
import {DeleteUserResponse, MessageResponse, User} from "../models/user";
import { UtilService } from './util.service';
import { StateService } from './state.service';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _gaoUserListSub = new BehaviorSubject<User[]>([]);
  gaoUserListSub$ = this._gaoUserListSub.asObservable();

  constructor(private httpService: HttpService, private util : UtilService, private stateService : StateService) {
  }

  getGaoUsers() {
    this.httpService.Get<any>(`/get-gao-user-list`).subscribe(response => {
      if (response?.gao_User_Info_List)
        this._gaoUserListSub.next(response?.gao_User_Info_List);
      else
        this._gaoUserListSub.next([]);
    });
  }

  addUser (formData: any): Observable<any> {
    const httpParams =  this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    return this.httpService.Post('/register-gao-info', httpParams, options);
  }

  saveUser(formData: any): Observable<any> {
    const httpParams =  this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    return this.httpService.Post('/edit-user-info', httpParams, options);
  }

  deleteUser(formData: any): Observable<DeleteUserResponse> {
    const httpParams =  this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    return this.httpService.Post('/delete-user', httpParams, options);
  }

  checkIfUserExists(email: string) : Observable<MessageResponse> {
    const params = { email: btoa(email) };
    return this.httpService.Post('/user/check-if-user-exists/', params);
  }

  validatePassword(apiUrl:string, password: string) : Observable<any> {
    const formData = { password: this.util.base64UrlEncode(password), user_id:this.stateService.user.user_Id };
    const httpParams =  this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    return this.httpService.Post(apiUrl, httpParams, options);
  }
}
